import React, {useEffect, useState} from "react";
import axios from "axios";

function MainResults() {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        let timestamp = new Date();
        timestamp = timestamp.getHours()+''+timestamp.getMinutes();
        const response = await axios.get(`/result/ACF2021/json/element333.json?ver=${timestamp}`);
        setData(response.data.items);
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData().then((r) => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function applyStaggeredAnimation(selector, numElements, delayIncrement) {
    const style = document.createElement('style');
    let css = "";
    for (let i = 1; i <= numElements; i++) {
      css += `${selector}:nth-child(${i}) {\n`;
      css += `  animation-delay: ${delayIncrement * (i - 1)}s;\n`;
      css += `}\n`;
    }
    style.textContent = css;
    document.head.appendChild(style);
  }
  applyStaggeredAnimation(".progress-in", 70, 0.1);

  let totSeats = 0;

  return (
      <>
        {isLoading ? (
            <div>Loading...</div>
        ) : error ? (
            <div>Error: {error.message}</div>
        ) : (
            <div id="main-results" className="card cardBorder">
              <div className="card-head">
                <div className="card-title"><h1>Delhi Election</h1><span>(70 Seats)</span></div>
                <div className="main-status"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path d="M1.92877 11.6991C2.47356 11.6739 2.93453 11.4644 3.3117 11.0705C3.68886 10.6765 3.88163 10.2072 3.88163 9.6624C3.88163 10.2072 4.06602 10.6765 4.44318 11.0705C4.82034 11.4644 5.28131 11.6739 5.8261 11.6991C5.28131 11.7242 4.82034 11.9337 4.44318 12.3277C4.26083 12.5134 4.11727 12.7335 4.02086 12.9753C3.92445 13.217 3.87712 13.4755 3.88163 13.7357C3.88163 13.1909 3.69724 12.7216 3.3117 12.3277C2.93453 11.9337 2.47356 11.7242 1.92877 11.6991ZM3.88163 5.66449C4.93768 5.6142 5.83448 5.20352 6.57204 4.43243C7.3096 3.66135 7.67838 2.74778 7.67838 1.68335C7.67838 2.74778 8.04716 3.66135 8.78472 4.43243C9.52228 5.20352 10.4191 5.60582 11.4835 5.66449C10.7879 5.69802 10.1509 5.89079 9.56418 6.25957C8.98587 6.61997 8.5249 7.10608 8.18126 7.70954C7.84601 8.313 7.67838 8.95836 7.67838 9.6624C7.67838 8.59796 7.3096 7.67602 6.57204 6.90493C5.83448 6.12547 4.93768 5.71478 3.88163 5.66449ZM6.66424 14.6912C7.46046 14.6577 8.13935 14.3476 8.69252 13.7693C9.24569 13.1909 9.52228 12.5037 9.52228 11.6991C9.52228 12.5037 9.79886 13.1909 10.352 13.7693C10.9052 14.3476 11.5757 14.6577 12.3719 14.6912C11.5757 14.7247 10.9052 15.0348 10.352 15.6132C9.79886 16.1915 9.52228 16.8787 9.52228 17.6833C9.52228 16.8787 9.24569 16.1915 8.69252 15.6132C8.16398 15.0511 7.43527 14.7198 6.66424 14.6912ZM12.3719 10.7184C13.1682 10.6849 13.8387 10.3748 14.3918 9.7965C14.945 9.21818 15.2132 8.53091 15.2132 7.71792C15.2132 8.52253 15.4898 9.2098 16.043 9.78812C16.5961 10.3664 17.275 10.6765 18.0713 10.7101C17.275 10.7436 16.5961 11.0537 16.043 11.632C15.4898 12.2103 15.2132 12.8976 15.2132 13.7022C15.2132 12.8976 14.9366 12.2103 14.3918 11.632C13.8387 11.0621 13.1682 10.752 12.3719 10.7184Z" fill="#f1831e"/></svg>
                  <div className="mainStat bjp" id="mainStat">BJP WINS</div>
                </div>
              </div>
              <div className="results">
                {
                  data.map((item, index) => {
                    return (
                        <div key={item.Party} className={`results-in ${item.Party.toLowerCase()}`}><div className="party">{item.Party}</div><div className={`seats ${item.Party.toLowerCase()}`}>{item.Lead}</div></div>
                    );
                  })
                }
              </div>
              <div className="progress">
                {data.map((item) => {
                  totSeats += Math.floor(item.Lead);
                  return (
                      <React.Fragment key={item.Party}>
                        {Array.from({ length: item.Lead }).map((_, i) => (
                            <div className={`progress-in ${item.Party.toLowerCase()}`} key={i}/>
                        ))}
                      </React.Fragment>
                  );
                })}

                {totSeats < 70 && (
                    <React.Fragment>
                      {Array.from({ length: 70 - totSeats }).map((_, i) => (
                          <div className="progress-in p_def" key={i}/>
                      ))}
                    </React.Fragment>
                )}
              </div>
              <div className="prev-result"><span>2020</span><svg xmlns="http://www.w3.org/2000/svg" width="7" height="8" viewBox="0 0 7 8" fill="none"><path d="M6.5 4L0.5 7.4641L0.5 0.535898L6.5 4Z" fill="#F81515"/></svg><div className="prev-result-in">AAP <span className="aap">62</span>  |  BJP <span className="bjp">8</span>  |  INC <span className="inc">0</span> |  OTH <span className="oth">0</span></div></div>
            </div>
        )
        }
      </>
  );
}

export default MainResults;
